import { Modal } from 'iview'
import langMap from '@/utils/language'
import store from '@/store'  
const beforeClose = {
  before_close_normal: (resolve) => {
    const lang = store.state.app.language; // 获取当前语言
    Modal.confirm({
      title: langMap.confirmClosePage[lang],
      okText: langMap.confirm[lang],
      cancelText: langMap.cancel[lang],
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        resolve(false)
      }
    })
  }
}

export default beforeClose
